/**
 * Filter Slice
 *
 * State and actions for filters, grouping, and sorting.
 */

import type { StateCreator } from 'zustand';
import type { FilterState, GroupingState, SortingState } from '@/types';
import { createDefaultGroupingState, createDefaultSortingState } from '@/utils/grouping';
import type { AppStore, FilterSlice } from '../types';

export const createFilterSlice: StateCreator<AppStore, [], [], FilterSlice> = (set, get) => ({
  filters: {
    status: [],
    assignees: [],
    tags: [],
    priority: [],
    search: '',
    path: null,
    dateRange: { start: null, end: null },
    hasAttachments: null,
    hasSubtasks: null,
    showCompleted: false,
  },
  grouping: createDefaultGroupingState(),
  sorting: createDefaultSortingState(),

  setFilters: (newFilters: Partial<FilterState>, options) => {
    const currentFilters = get().filters;
    const updatedFilters = { ...currentFilters, ...newFilters };

    if (!options?.skipCloseItems && newFilters.path !== undefined) {
      get().closeAllItems();
      set({ selectedTaskId: null });
    }

    set({ filters: updatedFilters });
  },

  setGrouping: (grouping: GroupingState) => set({ grouping }),
  setSorting: (sorting: SortingState) => set({ sorting }),
});
